module.exports = __webpack_public_path__ + "static/media/map-view.6b9afc44.svg";